export const AMERICA_NEW_YORK_TIMEZONE = 'America/New_York';
